<template>
  <div class="f-col full editor">
    <SiteList />
  </div>
</template>

<script>
import SiteList from "./SiteList";

export default {
  name: "Editor",
  components: {
    SiteList,
  },
  computed: {
    editor() {
      return this.$store.state.editor;
    },
  },
  async created() {
    try {
      this.$store.commit("TOGGLE_DISPLAY_LAYOUT", {
        menu: true,
        header: true,
        footer: true,
      });
      await this.$store.dispatch("EDITOR_CONTEXT_REQUEST");
    } catch (err) {
      console.warn(err);
    }
  },
};
</script>

<style scoped>
.editor {
  justify-content: flex-start;
  width: auto;
  height: 100%;
  padding: 10px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>